import { render } from "./LitStep5.vue?vue&type=template&id=18528536&scoped=true"
import script from "./LitStep5.vue?vue&type=script&lang=js"
export * from "./LitStep5.vue?vue&type=script&lang=js"

import "../form.css?vue&type=style&index=0&id=18528536&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18528536"]])

export default __exports__